import i18next from "i18next";

export enum EnrollmentMethodEnum {
    PERSONAL = 1,
    CALL,
    ONLINE
}

export const EnrollmentMethodLabel = (key: string) => ({ 
    [EnrollmentMethodEnum.PERSONAL]: i18next.t('PERSONAL'),
    [EnrollmentMethodEnum.CALL]: i18next.t('CALL'),
    [EnrollmentMethodEnum.ONLINE]: i18next.t('ONLINE')
})[key];

export const getEnrollmentMethods = () =>
    Object.values(EnrollmentMethodEnum).filter(x => !isNaN(Number(x))).map(element => {
        const value = `${element}`
        return {
            key: element,
            value: value,
            label: EnrollmentMethodLabel(value) ?? ""
        }
    });